// extracted by mini-css-extract-plugin
export default {"wrapper":"Payments_wrapper__Nd1gG","box_wrapper":"Payments_box_wrapper__-oQq7","text":"Payments_text__v1yXj"};